import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, first, mergeMap } from 'rxjs/operators';
import { CustomerAuthService } from '../public/customer-auth.service';
import { addToken, CUSTOMER_LOGOUT, isNonAuthEndpoint } from './token-helper';

@Injectable()
export class CustomerTokenInterceptor implements HttpInterceptor {
  constructor(
    public customerAuthService: CustomerAuthService,
    private store: Store<any>,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return this.store.pipe(
      first(),
      mergeMap((state) => {
        const tokens = state?.socialLoginState?.socialLoginState?.tokens;
        if (!request.headers.has('Authorization')) {
          const attachedJwt: string | null = tokens?.jwt || null;
          if (attachedJwt) {
            request = addToken(request, attachedJwt);
          }
          return next.handle(request).pipe(
            catchError((error) => {
              // Card #11561: a 401 on the customer JWT attached here means that
              // customer's session was refused, which is the customer session's
              // to end. Auth endpoints (sign-in, token refresh, membership
              // check) report their own failures to their callers. So does the
              // customer's own logout (story #11691): `signOut()` ends the
              // session itself on any answer, unless the session already
              // changed meanwhile, and the customer asked to leave, not to be
              // sent to the login.
              if (
                attachedJwt &&
                isNonAuthEndpoint(request) &&
                !request.context.get(CUSTOMER_LOGOUT) &&
                error instanceof HttpErrorResponse &&
                error.status === 401
              ) {
                this.customerAuthService.endRejectedSession(attachedJwt);
              }
              return throwError(error);
            }),
          );
        } else {
          return next.handle(request);
        }
      }),
    );
  }
}
